import i18next from "i18next";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Navbar } from "../../Components/Navbar/Navbar";
// import "../About/About.styles.css";

const Founder = () => {
    const { t } = useTranslation();
    const language = i18next.language;
    const { lang } = useParams();


    useEffect(() => {
        // document.title = "About - Cevher";
        // document.title = `${t('about-title')} - Cevher ${t('group')}`;
        if (lang) {
            i18next.changeLanguage(lang);
        }
        const updateTitle = () => {
            const newTitle = `${t('about-title')} | Cevher ${t('group')}`;
            document.title = newTitle;
            const newDescription = t("corporate-1");
            // Update og:title
            const ogTitleMeta = document.querySelector('meta[property="og:title"]');
            if (ogTitleMeta) {
                ogTitleMeta.setAttribute("content", newTitle);
            } else {
                const meta = document.createElement("meta");
                meta.setAttribute("property", "og:title");
                meta.setAttribute("content", newTitle);
                document.head.appendChild(meta);
            }

            // Update og:description
            const ogDescriptionMeta = document.querySelector('meta[property="og:description"]');
            if (ogDescriptionMeta) {
                ogDescriptionMeta.setAttribute("content", newDescription);
            } else {
                const meta = document.createElement("meta");
                meta.setAttribute("property", "og:description");
                meta.setAttribute("content", newDescription);
                document.head.appendChild(meta);
            }

            // Update description
            const descriptionMeta = document.querySelector('meta[name="description"]');
            if (descriptionMeta) {
                descriptionMeta.setAttribute("content", newDescription);
            } else {
                const meta = document.createElement("meta");
                meta.setAttribute("name", "description");
                meta.setAttribute("content", newDescription);
                document.head.appendChild(meta);
            }

        };

        updateTitle();

        const handleLanguageChanged = () => {
            updateTitle();
        };

        i18next.on("languageChanged", handleLanguageChanged);

        return () => {
            i18next.off("languageChanged", handleLanguageChanged);
        };
    }, [lang]);

    return (
        <div>
            <Navbar />
            <div className="c-wrapper">
                <div className="c-hero">
                    <div className="c-hero-background">
                        <picture>
                            <img
                                className="c-hero-image"
                                alt=""
                                src={require("../../assets/hero/about.3e9d3400.jpg")}
                            />
                        </picture>
                    </div>
                    <div className="c-hero-body">
                        <div className="c-about-caption">
                            <div
                                className="c-caption-section"
                                style={{ color: "#fff", textAlign: "center" }}
                            >
                                {t("corporate")}
                            </div>
                            <h1 className="c-caption-header">{t("our-founder-huseyin-ozyavuz-title")}</h1>
                        </div>
                    </div>
                </div>

                <div className="c-container">
                    <div className="c-row">
                        <div className="col c-col--lg-10 c-col--offset-lg-1">
                            <div style={{ paddingTop: "2rem", paddingBottom: "2rem" }}>

                                <img
                                    className="c-map-image"
                                    src={require("../../assets/content/huseyin_ozyavuz_portre.webp")}
                                    alt="Map"
                                />
                            </div>
                        </div>
                    </div>
                </div>


                <div className="c-container">
                    <div className="c-row">
                        <div className="col c-col--lg-8 c-col--offset-lg-2">
                            <div style={{ marginTop: "3rem" }}>
                                <p>
                                    <strong style={{ textAlign: "left" }}>
                                        {t("our-founder-1")}
                                    </strong>
                                </p>
                                <p>{t("our-founder-2")}</p>
                                <p>{t("our-founder-3")}</p>
                                <p>{t("our-founder-4")}</p>
                                <p>{t("our-founder-5")}</p>
                                <p>{t("our-founder-6")}</p>
                                <p>{t("our-founder-7")}</p>
                                <p>
                                    <strong>HÜSEYİN ÖZYAVUZ</strong>
                                </p>
                                <p>
                                    <strong>{t("founder-of-cevher")}</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Founder;
